import * as ActionTypes from './types';

export const updateClientsSorting = ({ sortBy, sortDesc }) => ({
  type: ActionTypes.UPDATE_CLIENTS_SORTING,
  sortBy,
  sortDesc,
});

export const resetClientsSorting = () => ({
  type: ActionTypes.RESET_CLIENTS_SORTING,
});

export const updateUsersSorting = ({ sortBy, sortDesc }) => ({
  type: ActionTypes.UPDATE_USERS_SORTING,
  sortBy,
  sortDesc,
});

export const resetUsersSorting = () => ({
  type: ActionTypes.RESET_USERS_SORTING,
});

export const updatePaymentsSorting = ({ sortBy, sortDesc }) => ({
  type: ActionTypes.UPDATE_PAYMENTS_SORTING,
  sortBy,
  sortDesc,
});

export const resetPaymentsSorting = () => ({
  type: ActionTypes.RESET_PAYMENTS_SORTING,
});

export const updateTerminalsSorting = ({ sortBy, sortDesc }) => ({
  type: ActionTypes.UPDATE_TERMINALS_SORTING,
  sortBy,
  sortDesc,
});

export const updateCardsSorting = ({ sortBy, sortDesc }) => ({
  type: ActionTypes.UPDATE_CARDS_SORTING,
  sortBy,
  sortDesc,
});

export const updateAchsSorting = ({ sortBy, sortDesc }) => ({
  type: ActionTypes.UPDATE_ACHS_SORTING,
  sortBy,
  sortDesc,
});

export const resetTerminalsSorting = () => ({
  type: ActionTypes.RESET_TERMINALS_SORTING,
});
